export default __webpack_public_path__ + "static/media/vignesh.1643f28e.jpg";